(function () {
  const STORAGE = {
    postcode: 'cart_postcode',
    threshold: 'cart_free_shipping_threshold'
  };

  // Postcode data is loaded from Shopify asset file (postcodes.json)
  // Use the known working CDN URL since file is uploaded to Shopify Files
  function getPostcodesDataUrl() {
    // First try window.POSTCODES_DATA_URL if set by Liquid template
    if (window.POSTCODES_DATA_URL && typeof window.POSTCODES_DATA_URL === 'string' && window.POSTCODES_DATA_URL.length > 0 && !window.POSTCODES_DATA_URL.includes('{{')) {
      return window.POSTCODES_DATA_URL;
    }
    // Fallback: Use the known working CDN URL
    return 'https://cdn.shopify.com/s/files/1/0670/1921/0965/files/postcodes.json';
  }

  const MIN_THRESHOLD_CENTS = 8000;

  // Postcode data (loaded from asset file - fetched fresh each time)
  let postcodeData = null;
  let dataLoadPromise = null;

  // Parse raw data from Sheet1 array format into postcodes map
  function parsePostcodeData(rawData) {
    const postcodeMap = {};
    
    // Handle both formats: {postcodes: {...}} or {Sheet1: [...]}
    if (rawData.postcodes) {
      // Already in correct format
      return rawData.postcodes;
    }
    
    if (rawData.Sheet1 && Array.isArray(rawData.Sheet1)) {
      // Parse from Sheet1 array format
      for (let i = 0; i < rawData.Sheet1.length; i++) {
        const row = rawData.Sheet1[i];
        const pc = String(row.postcode || row['postcode'] || '').trim();
        
        // Skip if no postcode
        if (!pc || !/^\d{4}$/.test(pc)) continue;
        
        // Get the relevant fields - handle string values from JSON
        const minOrderPriceStr = String(row['minimum order price'] || '').trim();
        const freeShippingPriceStr = String(row['free shipping price'] || '').trim();
        
        const minOrderPrice = parseFloat(minOrderPriceStr);
        const freeShippingPrice = parseFloat(freeShippingPriceStr);
        
        // If no minimum order price OR no free shipping price, we don't deliver there
        // Only include postcodes that have BOTH valid values
        if (!isNaN(minOrderPrice) && minOrderPrice > 0 && 
            !isNaN(freeShippingPrice) && freeShippingPrice > 0) {
          postcodeMap[pc] = {
            serviced: true,
            threshold: freeShippingPrice
          };
        }
        // If either field is missing/empty/invalid, don't add to map (means not serviced)
      }
    }
    
    return postcodeMap;
  }

  // Load postcode data from Shopify asset file (fetches fresh each time)
  async function loadPostcodeData() {
    // Return existing promise if already loading
    if (dataLoadPromise) {
      return dataLoadPromise;
    }

    // Always fetch fresh from Shopify CDN (fast, no caching needed)
    dataLoadPromise = (async function() {
      try {
        const urlToFetch = getPostcodesDataUrl();
        const response = await fetch(urlToFetch, {
          cache: 'no-store' // Always fetch fresh
        });
        
        if (!response.ok) {
          console.error('Failed to load postcodes.json:', response.status, response.statusText);
          return null;
        }
        
        const rawData = await response.json();
        
        // Parse the data (handles both formats)
        const parsed = parsePostcodeData(rawData);
        
        if (parsed && Object.keys(parsed).length > 0) {
          postcodeData = parsed;
          return parsed;
        }
        
        return null;
      } catch (e) {
        console.error('Error loading postcode data:', e);
        return null;
      } finally {
        dataLoadPromise = null;
      }
    })();

    return dataLoadPromise;
  }

  // Look up postcode in loaded data (synchronous - instant)
  function lookupPostcode(postcode) {
    // Use in-memory data if available
    if (postcodeData) {
      return postcodeData[postcode] || null;
    }
    
    return null;
  }

  // Initialize data load on page load (non-blocking)
  function initPostcodeData() {
    // Wait a tiny bit to ensure window.POSTCODES_DATA_URL is set by Liquid template
    setTimeout(function() {
      // Load in background (fetches fresh each time)
      loadPostcodeData().catch(function(err) {
        console.error('Background postcode data load failed:', err);
      });
    }, 10);
  }

  let unlockTimer = null;
  let scheduled = false;
  let lastRun = 0;

  function getStoredThreshold() {
    const v = sessionStorage.getItem(STORAGE.threshold);
    return v ? parseInt(v, 10) : null;
  }

  function getStoredPostcode() {
    return sessionStorage.getItem(STORAGE.postcode);
  }

  function findContainer() {
    const drawer = document.querySelector('#sidebar-cart');
    if (!drawer) return null;
    return drawer.querySelector('[data-shipping-notice-container]');
  }

  function getUI(container) {
    if (!container) return null;
    return {
      container,
      postcodeUnlock: container.querySelector('[data-postcode-unlock]'),
      shippingNotice: container.querySelector('[data-shipping-notice]'),
      postcodeInput: container.querySelector('[data-postcode-input]'),
      editPostcodeBtn: container.querySelector('[data-edit-postcode-btn]'),
      errorMsg: container.querySelector('[data-postcode-error]'),
      shippingText: container.querySelector('[data-shipping-text]'),
      progressBar: container.querySelector('[data-progress-bar]'),
      progressEndCap: container.querySelector('[data-progress-end-cap]'),
      thresholdLabel: container.querySelector('[data-threshold-label]'),
      reachedColor: container.getAttribute('data-free-shipping-reached-color'),
      notReachedColor: container.getAttribute('data-free-shipping-not-reached-color')
    };
  }

  function showError(container, msg) {
    const ui = getUI(container);
    if (!ui?.errorMsg) return;
    ui.errorMsg.textContent = msg;
    ui.errorMsg.style.display = 'block';
  }

  function clearError(container) {
    const ui = getUI(container);
    if (!ui?.errorMsg) return;
    ui.errorMsg.style.display = 'none';
  }

  function parseMoneyToCents(text) {
    if (!text) return null;
    const cleaned = text.replace(/[^\d.,]/g, '');
    if (!cleaned) return null;
    const normalized = cleaned.replace(/,/g, '');
    const num = parseFloat(normalized);
    if (Number.isNaN(num)) return null;
    return Math.round(num * 100);
  }

  function getCartTotalCentsFromDOM() {
    const drawer = document.querySelector('#sidebar-cart');
    if (!drawer) return null;
    const subtotalEl = drawer.querySelector('[data-cart-subtotal]');
    if (!subtotalEl) return null;
    return parseMoneyToCents(subtotalEl.textContent || '');
  }

  function render(thresholdCents) {
    const container = findContainer();
    const ui = getUI(container);
    if (!ui) return;

    const storedPostcode = getStoredPostcode();
    const storedThreshold = thresholdCents;

    if (storedPostcode && storedThreshold) {
      if (ui.postcodeUnlock) ui.postcodeUnlock.style.display = 'none';
      if (ui.shippingNotice) ui.shippingNotice.style.display = 'block';
    } else {
      if (ui.postcodeUnlock) ui.postcodeUnlock.style.display = 'block';
      if (ui.shippingNotice) ui.shippingNotice.style.display = 'none';
      return;
    }

    if (ui.thresholdLabel) {
      ui.thresholdLabel.textContent = '$' + (storedThreshold / 100).toFixed(0);
    }

    const cartTotalCents = getCartTotalCentsFromDOM();

    // If drawer is mid-render and subtotal not ready yet, show a safe placeholder (no blank UI)
    if (cartTotalCents == null) {
      if (ui.shippingText) ui.shippingText.textContent = 'Updating cart…';
      if (ui.progressBar) ui.progressBar.style.width = '0%';
      if (ui.progressEndCap) ui.progressEndCap.style.display = 'block';
      if (ui.notReachedColor && ui.shippingNotice) ui.shippingNotice.style.backgroundColor = ui.notReachedColor;
      return;
    }

    const reached = cartTotalCents >= storedThreshold;

    if (ui.shippingNotice) {
      if (reached && ui.reachedColor) ui.shippingNotice.style.backgroundColor = ui.reachedColor;
      if (!reached && ui.notReachedColor) ui.shippingNotice.style.backgroundColor = ui.notReachedColor;
    }

    if (ui.shippingText) {
      if (reached) {
        ui.shippingText.textContent = 'Free shipping unlocked!';
      } else {
        const remainingCents = storedThreshold - cartTotalCents;
        ui.shippingText.textContent = '$' + (remainingCents / 100).toFixed(2) + ' from free shipping!';
      }
    }

    const pct = Math.min(100, Math.max(0, (cartTotalCents / storedThreshold) * 100));
    if (ui.progressBar) ui.progressBar.style.width = pct + '%';
    if (ui.progressEndCap) ui.progressEndCap.style.display = reached ? 'none' : 'block';
  }

  function scheduleUpdate() {
    // Hard throttle: don’t allow > 1 update per ~80ms
    const now = Date.now();
    if (now - lastRun < 80) return;

    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      lastRun = Date.now();
      const threshold = getStoredThreshold();
      if (threshold) render(threshold);
      else render(null);
    });
  }

  async function handleUnlock(postcode, container) {
    const ui = getUI(container);
    if (!ui?.postcodeInput) return;

    const pc = (postcode || '').trim();
    if (!/^\d{4}$/.test(pc)) {
      showError(container, 'Please enter a valid 4-digit postcode');
      return;
    }

    clearError(container);

    ui.postcodeInput.disabled = true;
    ui.postcodeInput.style.opacity = '0.7';
    ui.postcodeInput.style.cursor = 'wait';

    try {
      // Fetch fresh data each time (fast from Shopify CDN)
      await loadPostcodeData();
      
      // Look up postcode (instant - uses in-memory or cached data)
      let data = lookupPostcode(pc);
      
      // If postcode not found in data, we don't deliver there
      if (!data) {
        showError(container, 'This postcode is not currently serviced by us');
        ui.postcodeInput.disabled = false;
        ui.postcodeInput.style.opacity = '1';
        ui.postcodeInput.style.cursor = 'text';
        ui.postcodeInput.focus();
        return;
      }

      // If data exists but serviced is false, also show error
      if (!data.serviced) {
        showError(container, 'This postcode is not currently serviced by us');
        ui.postcodeInput.disabled = false;
        ui.postcodeInput.style.opacity = '1';
        ui.postcodeInput.style.cursor = 'text';
        ui.postcodeInput.focus();
        return;
      }

      // Convert threshold from dollars to cents
      const thresholdCents = Math.max(MIN_THRESHOLD_CENTS, Math.round(data.threshold * 100));
      sessionStorage.setItem(STORAGE.postcode, pc);
      sessionStorage.setItem(STORAGE.threshold, String(thresholdCents));

      // re-enable input for next time (edit)
      ui.postcodeInput.disabled = false;
      ui.postcodeInput.style.opacity = '1';
      ui.postcodeInput.style.cursor = 'text';

      // Immediately render with the new threshold (don't wait for scheduleUpdate)
      render(thresholdCents);
    } catch (e) {
      console.error('Postcode unlock error:', e);
      console.error('Error details:', {
        message: e.message,
        stack: e.stack,
        name: e.name
      });
      showError(container, 'Unable to verify postcode. Please try again.');
      ui.postcodeInput.disabled = false;
      ui.postcodeInput.style.opacity = '1';
      ui.postcodeInput.style.cursor = 'text';
    }
  }

  // Delegated events (no rebinding loops)
  document.addEventListener('input', function (e) {
    const el = e.target;
    if (!el?.matches?.('[data-postcode-input]')) return;

    el.value = (el.value || '').replace(/[^\d]/g, '');

    if (el.value.length === 4) {
      const captured = el.value;
      const container = el.closest('[data-shipping-notice-container]');

      if (unlockTimer) clearTimeout(unlockTimer);
      unlockTimer = setTimeout(() => {
        unlockTimer = null;
        handleUnlock(captured, container);
      }, 120);
    }
  });

  document.addEventListener('click', function (e) {
    const btn = e.target?.closest?.('[data-edit-postcode-btn]');
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    sessionStorage.removeItem(STORAGE.postcode);
    sessionStorage.removeItem(STORAGE.threshold);

    scheduleUpdate();

    const container = btn.closest('[data-shipping-notice-container]');
    const ui = getUI(container);
    if (ui?.postcodeInput) {
      ui.postcodeInput.value = '';
      ui.postcodeInput.disabled = false;
      ui.postcodeInput.style.opacity = '1';
      ui.postcodeInput.style.cursor = 'text';
      setTimeout(() => ui.postcodeInput.focus(), 50);
    }

    clearError(container);
  }, true);

  // Observe drawer swaps + subtotal changes (ONLY inside drawer)
  function attachObservers() {
    const drawer = document.querySelector('#sidebar-cart');
    if (!drawer) return;

    if (drawer.dataset.postcodeObs === '1') return;
    drawer.dataset.postcodeObs = '1';

    // When drawer content changes, reschedule (but don’t do heavy work in observer)
    const drawerObs = new MutationObserver(() => scheduleUpdate());
    drawerObs.observe(drawer, { childList: true, subtree: true });

    scheduleUpdate();
  }

  document.addEventListener('DOMContentLoaded', function() {
    attachObservers();
    initPostcodeData(); // Initialize postcode data on page load (fetches fresh)
  });
  setTimeout(attachObservers, 500);
  setTimeout(attachObservers, 1500);
  
  // Initialize data load as soon as script loads (non-blocking)
  initPostcodeData();

  // Hook if your theme emits pubsub cart update
  if (window.pubsub?.subscribe) {
    window.pubsub.subscribe('cart-update', () => scheduleUpdate());
  }
})();